import AdditionBottomWindow from "./AdditionBottomWindow";

export default AdditionBottomWindow;